export const navList = [
  {
    route: "/",
    name: "HOME",
  },
  {
    route: "/product-list",
    name: "PRODUCTS",
  },
  {
    route: "/settings/account",
    name: "ACCOUNT",
  },
];
